import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "content", "folderId", "onChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Flex, { Box } from 'components/Flex';
import Button from 'components/Button';
import MoveModal from 'components/MoveModal';
import Icon from 'components/Icon';
import FormField from 'components/FormField';
import useUniqueId from 'hooks/useUniqueId';
import { useFetchFolders } from 'actions/folders';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var AssetLibraryField = function AssetLibraryField(_ref) {
  var id = _ref.id,
    content = _ref.content,
    folderId = _ref.folderId,
    onChange = _ref.onChange,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useFetchFolders = useFetchFolders(),
    folders = _useFetchFolders.items,
    isLoading = _useFetchFolders.isLoading;
  var currentFolder = folders.find(function (folder) {
    return folder.id === folderId;
  });
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showMoveModal = _useState2[0],
    setShowMoveModal = _useState2[1];
  var currentContent = _objectSpread(_objectSpread({}, content), {}, {
    id: (content === null || content === void 0 ? void 0 : content.id) || null,
    name: (content === null || content === void 0 ? void 0 : content.name) || '',
    parent_id: folderId
  });
  var uniqueId = useUniqueId(id);
  return /*#__PURE__*/_jsx(FormField, _objectSpread(_objectSpread({
    as: "span",
    label: t('form_asset_library'),
    labelId: uniqueId
  }, otherProps), {}, {
    children: /*#__PURE__*/_jsxs(Flex, {
      gap: "xxs",
      alignItems: "center",
      children: [/*#__PURE__*/_jsxs(Box, {
        overflow: "ellipsis",
        children: [/*#__PURE__*/_jsx(Icon, {
          dimmed: true,
          vAlign: true,
          name: "asset-folder",
          mr: "xs"
        }), (currentFolder === null || currentFolder === void 0 ? void 0 : currentFolder.name) || t('top_level')]
      }), /*#__PURE__*/_jsxs(Box, {
        children: [/*#__PURE__*/_jsx(Button, {
          size: "small",
          variant: "transparent",
          onClick: function onClick() {
            return setShowMoveModal(true);
          },
          isLoading: isLoading,
          "aria-label": t('actions_change_asset_location'),
          children: t('actions_change')
        }), showMoveModal && /*#__PURE__*/_jsx(MoveModal, {
          onClose: function onClose() {
            return setShowMoveModal(false);
          },
          itemsToMove: [currentContent],
          folders: folders,
          isMoving: false,
          onMoveItems: function onMoveItems(newFolderLocation) {
            if (newFolderLocation) {
              onChange(newFolderLocation.id);
            }
          },
          initialTargetFolderId: folderId
        })]
      })]
    })
  }));
};
export default AssetLibraryField;